// utils/dirtyMini.js

// pega só os 4 campos; usa Guid como chave (ou índice se faltar Guid)
export function makeSnapshot(list) {
  return (list || []).map((it, idx) => ({
    key: it.Guid || `idx:${idx}`,
    v: JSON.stringify({
      Nome: (it.Nome || '').trim(),
      CpfCnpj: (it.CpfCnpj || '').trim(),
      Assinatura: String(it.Assinatura ?? '').trim(),
      Email: (it.Email || '').trim().toLowerCase(),
    }),
  }));
}

export function hasChanges(list, snapshot) {
  if (!snapshot || !snapshot.length) return true; // sem snapshot => considere alterado
  const curr = makeSnapshot(list);
  // se algum item novo (key não existe) ou valor diferente -> mudou
  return curr.some(c => {
    const prev = snapshot.find(p => p.key === c.key);
    return !prev || prev.v !== c.v;
  });
}
